import { render, staticRenderFns } from "./Packaging_masters.vue?vue&type=template&id=25d1900a&"
import script from "./Packaging_masters.vue?vue&type=script&lang=js&"
export * from "./Packaging_masters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports